import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { aqua, info, primary, error, green, mint, secondary, purple, rose, success, warning } from "./colors";
export var white = "#ffffff";
export var black = "#000000";
export var background = "#EEEEEE";
export var orange = "#FFAB00";
export var red = "#F5222D";
export var gray = "#8593A3";
export var bajajPrimaryBlue = '#0052ff';
export var mobilenoblack = "#1B1D21";
export var faintblue = "#F4F7FA";
export var lightGray = "#EFF2F5";
export var faintGray = "#DEE4EB";
export var gradientblue = "#5189D6";
export var gradientdarkblue = "#1C4BA3";
export var lightBlue = "#7AB2FF";
export var faintErrorBg = "#FFF1F0";
export var secondaryTextGray = "#6A7682";
export var mainColor = "#000000";
export var primaryText = "#151522";
var palette = {
    primary: _objectSpread({
        contrastText: '#fff',
        main: primary[500],
        light: primary[50],
        dark: primary[900]
    }, primary),
    secondary: _objectSpread({
        main: secondary[500],
        contrastText: '#fff',
        light: secondary[50],
        dark: secondary[900]
    }, secondary),
    text: {
        primary: secondary[900],
        secondary: secondary[600],
        tertiary: secondary[500],
        disabled: secondary[300]
    },
    info: _objectSpread({
        main: info[500],
        contrastText: '#fff',
        light: info[50],
        dark: info[900]
    }, info),
    warning: _objectSpread({
        main: warning[500],
        contrastText: '#fff',
        light: warning[50],
        dark: warning[900]
    }, warning),
    error: _objectSpread({
        main: error[500],
        contrastText: '#fff',
        light: error[50],
        dark: error[900]
    }, error),
    success: _objectSpread({
        main: success[500],
        contrastText: '#fff',
        light: success[50],
        dark: success[900]
    }, success),
    purple: _objectSpread({
        main: purple[500],
        contrastText: '#fff',
        dark: purple[900],
        light: purple[50]
    }, purple),
    aqua: _objectSpread({
        main: aqua[500],
        contrastText: '#fff',
        dark: aqua[900],
        light: aqua[50]
    }, aqua),
    mint: _objectSpread({
        main: mint[500],
        contrastText: '#fff',
        dark: mint[900],
        light: mint[50]
    }, mint),
    green: _objectSpread({
        main: green[500],
        contrastText: '#fff',
        dark: green[900],
        light: green[50]
    }, green),
    rose: _objectSpread({
        main: rose[500],
        contrastText: '#fff',
        dark: rose[900],
        light: rose[50]
    }, rose),
    background: {
        default: secondary[50],
        paper: '#fff',
        secondary: secondary[50]
    }
};
export default palette;
